module.exports = __webpack_public_path__ + "static/img/客户墙00045.6fbe917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/客户墙00045.png
// module id = SYbX
// module chunks = 1